module.exports = __webpack_public_path__ + "img/todo_a.b32565e4.png";